import React from 'react';
import { useTranslation } from 'react-i18next';
import UserPickerModal from 'screens/UserPickerModal';
import { jsx as _jsx } from "react/jsx-runtime";
export var NO_OWNER_ID = 'no-owner-selection';
var OwnerPickerModal = function OwnerPickerModal(_ref) {
  var value = _ref.value,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'playlist' : _ref$contentType,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var noOwnerItem = {
    id: NO_OWNER_ID,
    name: t('property_no_owner'),
    is_deleted: false
  };
  return /*#__PURE__*/_jsx(UserPickerModal, {
    isSingleItemPicker: true,
    includeDeletedUsers: false,
    title: t('actions_select_owner'),
    users: value ? [{
      id: value.id,
      name: value.displayName,
      is_deleted: value.isDeleted
    }] : [noOwnerItem],
    extraItems: [noOwnerItem],
    filterForAdminRole: contentType,
    onClose: onClose,
    onSubmit: onSubmit
  });
};
export default OwnerPickerModal;